import { KeycloakConfig, UpdateStrategy } from "@ogs/ngx-keycloak";
import { HTTP_CONFIG } from "./http-configs/http.config";
import { mergeHttpConfig } from "@ogs-gmbh/ngx-http";
import { CORE_ROUTE_NAMES } from "@core/constants/core-route-names";

export const KEYCLOAK_CONFIG: KeycloakConfig = {
  keycloak: {
    resource: "pls_client",
    realm: "bcl",
    storageKey: "auth-token",
    storageType: window.localStorage,
    useEmailAsCurrentUser: false,
    updateStrategy: UpdateStrategy.BOTH,
    guardFallbackUrl: CORE_ROUTE_NAMES.authenticate,
    reverseGuardFallbackUrl: CORE_ROUTE_NAMES.projects
  },
  http: mergeHttpConfig(HTTP_CONFIG, {
    path: "/auth"
  })
};
